import { getUploadUrl } from "./api";

export async function uploadImage(
  file: File,
  token: string
): Promise<{ imageKey: string; thumbnailKey: string }> {
  const { uploadUrl, imageKey } = await getUploadUrl(file.name, file.type, token);

  const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });

  if (!res.ok) throw new Error(`Image upload failed: HTTP ${res.status}`);

  return { imageKey, thumbnailKey: imageKey };
}
